import axios from "axios";
import settings from "../settings";
export default {
    namespaced: true,
    actions: {
        async getSearchHistory({ commit }, path) {
            let params = {
                path
            };
            let response = await axios.get(settings.api_url + "/search-history/", { params });
            let data = response.data;
            commit("setSearchHistory", data.searches);
        }
    },
    state: {
        searchHistory: []
    },
    mutations: {
        setSearchHistory(state, data) {
            state.searchHistory = data;
        }
    }
};
